import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LoggerService } from './core/services/logger.service';
import { I18nService } from './core/services/i18n.service';
import { AnimationPreferenceService } from './core/services/animation-preference.service';
import { ViewportService } from './core/services/viewport.service';
import { InactivityService } from './core/services/inactivity.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Autolac';
  private routerSubscription: any;

  constructor(
    private router: Router,
    private logger: LoggerService,
    private i18nService: I18nService,
    private animationPreference: AnimationPreferenceService,
    private viewport: ViewportService,
    private inactivityService: InactivityService
  ) {
    const savedLanguage = localStorage.getItem('autolac_language');
    if (savedLanguage && ['pt', 'en', 'es'].includes(savedLanguage)) {
      this.i18nService.setLanguage(savedLanguage as 'pt' | 'en' | 'es');
    }
    // Apply alert-animation flags before any view renders so the first
    // paint already respects the user/device profile (TASK-58394).
    this.animationPreference.initialize();
    // Seed vp-mobile/vp-tablet/vp-desktop body classes and matchMedia
    // listeners on app start, before any feature page is reached
    // (TASK-59145). MobileBlockedGuard depends on this on the very first
    // navigation.
    this.viewport.initialize();
  }

  ngOnInit(): void {

    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.logger.log('=== NAVEGAÇÃO DO ROUTER ===');
        this.logger.log('URL:', event.url);
        this.logger.log('URL completa:', window.location.href);
        this.logger.log('Hash:', window.location.hash);
        this.logger.log('Query params:', window.location.search);

        if (event.url.includes('/auth/callback')) {
          this.logger.log('✅ Rota de callback detectada pelo Router!');
          this.logger.log('Hash na URL:', window.location.hash);

          setTimeout(() => {
            this.logger.log('Verificação após delay:');
            this.logger.log('Hash:', window.location.hash);
            this.logger.log('URL completa:', window.location.href);
          }, 200);
        }
      });

    window.addEventListener('hashchange', () => {
      this.logger.log('=== HASH CHANGE EVENT ===');
      this.logger.log('Hash:', window.location.hash);
      this.logger.log('URL completa:', window.location.href);
    });

    this.logger.log('=== APP COMPONENT INICIADO ===');
    this.logger.log('URL inicial:', window.location.href);
    this.logger.log('Hash inicial:', window.location.hash);
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
